import { render, staticRenderFns } from "./CursosIndex.vue?vue&type=template&id=10436a2c&scoped=true"
import script from "./CursosIndex.vue?vue&type=script&lang=js"
export * from "./CursosIndex.vue?vue&type=script&lang=js"
import style0 from "./CursosIndex.vue?vue&type=style&index=0&id=10436a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10436a2c",
  null
  
)

export default component.exports